import styled from"@emotion/styled";import{FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import{Caption400Neutral500}from"@wp/src/components/common/atoms";export const LoaderContainer=styled(FlexLayout)`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  border: none;
  box-sizing: border-box;
  padding: 16px 0;
`;export const Container=styled(FlexLayout)`
  border: none;
  box-sizing: border-box;

  ${mediaQuery({width:["100%","376px"],maxWidth:["376px"]})}
`;export const LabelAndProgressContainer=styled(FlexLayout)``;export const LabelsContainer=styled(FlexLayout)``;export const IconContainer=styled(FlexLayout)`
  height: 96px;
  min-width: 96px;
  max-width: 96px;
  align-items: center;
`;export const Description=styled(Caption400Neutral500)`
  color: ${props=>props.theme.colors.neutral800};
`;